export const TRANSPORT_MODE_SEA = 'sea'
export const TRANSPORT_MODE_AIR = 'air'
export const TRANSPORT_MODE_SEA_AIR = 'seaAir'
export const TRANSPORT_MODE_RAIL = 'rail'
export const TRANSPORT_MODE_TRUCK = 'truck'
export const TRANSPORT_MODE_BARGE = 'barge'

type TTransportModeSea = typeof TRANSPORT_MODE_SEA
type TTransportModeAir = typeof TRANSPORT_MODE_AIR
type TTransportModeSeaAir = typeof TRANSPORT_MODE_SEA_AIR
type TTransportModeRail = typeof TRANSPORT_MODE_RAIL
type TTransportModeTruck = typeof TRANSPORT_MODE_TRUCK
type TTransportModeBarge = typeof TRANSPORT_MODE_BARGE

export type TTransportOrCarriageMode =
  | TTransportModeSea
  | TTransportModeAir
  | TTransportModeSeaAir
  | TTransportModeRail
  | TTransportModeTruck
  | TTransportModeBarge
